import styled from 'styled-components';
import { commonStyledProps, CommonStyledProps } from './common';

export const Card = styled.div<CommonStyledProps>(props => ({
  backgroundColor: '#FFF',
  borderRadius: 4,
  boxShadow: '0 0 4px 0 rgba(189,189,189,0.50)',
  ...commonStyledProps(props),
}));
